// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader
import App from './App'
import router from './router'
import VeeValidate from 'vee-validate';
Vue.config.productionTip = false
import firebase from 'firebase'
import './components/firebaseinit'
import store from './store'

// Vue-Analytics (Google Analytics)
import VueAnalytics from "vue-analytics";
Vue.use(VueAnalytics, {
  id: "UA-138229934-3",
  router
});

let app;
firebase.auth().onAuthStateChanged(user => {
  if(!app) {
    app = new Vue({
      el: '#app',
      router,
      store,
      components: { App },
      template: '<App/>'
    })
  }
})


/* eslint-disable no-new */
Vue.use(VeeValidate)
Vue.use(Vuetify)



// WEBPACK FOOTER //
// ./src/main.js